module.exports = __webpack_public_path__ + "img/s5CardTop.a7718f03.webp";